import React, { useRef, useState } from "react";
import PageHeading from "../../../components/PageHeading";
import Button from "../../../components/btn/Button";
import { HiOutlineArrowRight } from "react-icons/hi";
import RowTxt from "../../../components/RowTxt";
import { motion } from "framer-motion";
import Modal from "../../../components/modal/Modal";
import { shallowEqual, useSelector } from "react-redux";
import PageLoading from "../../../components/PageLoading";
import store from "../../../redux/store";
import { DeleteIcon } from "../../../utils/utils";
import { get_commercial_sales_list } from "../trasactionsSlice";
import moment from "moment";
import Table from "../../../components/table/Table";
import {
  AddButton,
  BackButton,
  HelpButton,
} from "../../../components/btn/Buttons";
import {
  Calcle_E_way_bill_api,
  Cancle_E_Invoice_api,
  E_Invoice_api,
  E_way_bill_api,
  commercial_cylinder_sales_API,
} from "../../../utils/apis";
import { toast } from "react-toastify";
import SmallModal from "../../../components/modal/SmallModal";
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";

import { Pagination3 } from "../../../components/pagination/pagination";
import NoData from "../../../components/NoData";

import ReactToPrint from "react-to-print";
import { UnitFunction } from "../../../utils/validation";
import SearchApiHook from "../../../CustomHooks/SearchApiHook";
import { ReduceFunction } from "../../../utils/Hook/ReduceFunction";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { TbFileInvoice } from "react-icons/tb";
import { downloadFile } from "../../../utils/Hook/DownloadFile";
import Tooltip from "../../../components/tooltip/Tooltip";
import ReactPrint from "../../../components/ReactPrint";
import TaxInvoice3 from "../../../components/TaxInvoice/TaxInvoice3";
import AddCommercial from "../../../components/AddComponent/AddCommercial";

export const ComercialCylSale = () => {
  const previewRef = useRef(null);

  const [isAdd, setIsAdd] = useState(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [mess, setMess] = useState("");
  const [id, setId] = useState("");
  const [viewItem, setViewItem] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [entries, setEntries] = useState("5");
  const [totalCount, setTotalCount] = useState("");
  const [prevSearch, setPrevSearch] = useState("");
  const [SearchCount, setSearchCount] = useState(0);
  const [SerchInput, setSearchInput] = useState("");
  const navigate = useNavigate();

  const {
    other: { user_id, emp_id, user_type },
    transactions: { commercial_sales_list, commercial_sales_loading },
    profile: { token_status },
  } = useSelector(
    (state) => ({
      other: state.other,
      transactions: state.transactions,
      profile: state.profile,
    }),
    shallowEqual
  );

  // console.log("====================================");
  // console.log(" viewItem ===", viewItem);
  // console.log("====================================");

  const obj = {
    page: pageNo,
    limit: entries,
    setTotalCount: setTotalCount,
    setSearchCount: setSearchCount,
    search: SerchInput,
  };

  const fetchData = () => {
    store.dispatch(get_commercial_sales_list(obj));
  };

  SearchApiHook(fetchData, SerchInput?.trim(), prevSearch, [entries, pageNo]);

  const onDelete_item = async () => {
    setOpen(false);
    const body = new FormData();
    body.append("action", "delete");
    body.append("agencyid", user_id);
    body.append("id", id);
    if (emp_id) {
      body.append("emp_code", emp_id);
    }
    const deletedBy = emp_id ? emp_id : user_id;
    body.append("deleted_by", deletedBy);

    const responce = await commercial_cylinder_sales_API(body);
    if (responce.success) {
      toast(responce?.message);
      await store.dispatch(get_commercial_sales_list(obj));
    } else if (!responce?.success) {
      setMess(responce?.message);
      setOpen1(true);
    }
  };

  const genrate_e_invoice = async (sr_no, id) => {
    try {
      setLoading(true);
      const res = await E_Invoice_api({
        document_number: sr_no,
        agencyid: user_id,
      });
      setLoading(false);

      if (res.success) {
        // const pdfUrl =
        //   res?.data?.results?.message?.EinvoicePdf || res?.data?.einvoice_url;
        toast.success(res.message);
        // await store.dispatch(get_commercial_sales_list(obj));
        // const data = commercial_sales_list?.filter((v) => v?.ID === id)?.[0];
        // await downloadFile(
        //   res?.data?.results?.message?.EinvoicePdf || res?.data?.einvoice_url
        // );
        // setViewItem(data)
        store.dispatch(get_commercial_sales_list(obj));
      } else {
        setOpen1(true);
        setMess(res.message);
      }
    } catch (error) {
      console.log("error ===", error);
    }
  };

  const genrate_e_way_bill = async (sr_no) => {
    try {
      setLoading(true);
      const res = await E_way_bill_api({
        document_number: sr_no,
        agencyid: user_id,
      });
      setLoading(false);
      if (res.success) {
        // await downloadFile(
        //   "https://" +
        //     (res?.data?.results?.message?.url || res?.data?.ewaybill_url)
        // );
        toast.success(res.message);
        store.dispatch(get_commercial_sales_list(obj));
      } else if (!res.success) {
        setOpen1(true);
        setMess(res.message);
      }
    } catch (error) {
      console.log("error ===", error);
    }
  };

  const cancle_e_way_bill = async (bill_no) => {
    try {
      setLoading(true);
      const res = await Calcle_E_way_bill_api({
        eway_bill_number: bill_no,
        agencyid: user_id,
      });
      setLoading(false);
      if (res.success) {
        toast.success(res.message);
        store.dispatch(get_commercial_sales_list(obj));
        setOpenView(false);
      } else if (!res.success) {
        setOpen1(true);
        setMess(res.message);
      }
    } catch (error) {
      console.log("error ===", error);
    }
  };

  const print_e_way_bill = async (url) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.onload = () => {
        newWindow.print();
      };
    } else {
      alert("Popup blocked! Please allow popups for this site.");
    }
  };

  // Example usage:

  return (
    <div className="container">
      <PageHeading
        title={"COMMERCIAL CYLINDER SALES"}
        right={
          <>
            <AddButton
              onClick={() => {
                setIsAdd(true);
              }}
            />
            <BackButton />
            <HelpButton
              link={[
                "https://youtu.be/oEzSuwSIkRg",
                "https://youtu.be/rrX-pqA7h68",
              ]}
            />
          </>
        }
      />

      {/* {pdfUrl && <PrintComp url={pdfUrl} />} */}

      <Pagination3
        totalCount={totalCount > SearchCount ? SearchCount : totalCount}
        SerchInput={SerchInput}
        serchChange={(e) => {
          setSearchInput(e.target.value);
          setPrevSearch(SerchInput);
          setPageNo(1);
        }}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
      >
        {commercial_sales_loading ? (
          <PageLoading />
        ) : commercial_sales_list?.length == 0 ? (
          <NoData mt="2rem" />
        ) : (
          <div className="grid">
            {commercial_sales_list.map((v, i) => (
              <div className="card" key={i}>
                <div>
                  <div className="card-heading">
                    {v?.cvo_name || v?.CUST_NAME}
                  </div>
                  <RowTxt
                    title={"Invoice No."}
                    value={
                      <ReactToPrint
                        trigger={() => (
                          <div
                            onMouseEnter={() => {
                              setViewItem(v);
                            }}
                            onTouchStart={() => {
                              setViewItem(v);
                            }}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setViewItem(v);
                            }}
                          >
                            {v?.SR_NO}
                          </div>
                        )}
                        content={() => previewRef.current}
                        documentTitle={`${v?.cvo_name || v?.CUST_NAME}-${
                          v?.SR_NO
                        }`}
                      />
                    }
                  />
                  <RowTxt
                    title={"Invoice Date"}
                    value={moment(v?.SI_DATE).format("DD-MMM-YYYY")}
                  />
                  <RowTxt
                    title={"Total Amount"}
                    value={Number(v?.SI_AMOUNT).toFixed(2)}
                  />
                  <RowTxt
                    title={"Payment Terms"}
                    value={
                      v?.PAYMENT_TERMS == "1"
                        ? "Cash"
                        : v?.PAYMENT_TERMS == "2"
                        ? "Credit"
                        : ""
                    }
                  />
                  <RowTxt
                    title={"TDS/TCS"}
                    value={
                      v?.SYNC_FLAG == 1
                        ? "TDS"
                        : v?.SYNC_FLAG == 2
                        ? "TCS"
                        : v?.SYNC_FLAG == 3
                        ? "NA"
                        : ""
                    }
                  />
                  <RowTxt title={"Godown Address"} value={v?.GODOWN_NAME} />
                  {v?.PO_NO && <RowTxt title={"PO Number"} value={v?.PO_NO} />}
                  {v?.PAYMENT_TERMS == "1" && (
                    <>
                      {v?.CUST_GSTIN && (
                        <RowTxt title={"GST Number"} value={v?.CUST_GSTIN} />
                      )}
                      <RowTxt
                        title={"Cash Recieved"}
                        value={v?.CASH_RECEIVED}
                      />
                      <RowTxt
                        title={"Online Recieved"}
                        value={v?.AMOUNT_RECEIVED_ONLINE}
                      />
                      {v?.TRANSACTION_ID && (
                        <RowTxt
                          title={"Transaction Id"}
                          value={v?.TRANSACTION_ID}
                        />
                      )}
                      {v?.RECEIVED_FROM && (
                        <RowTxt
                          title={"Cash Recieved From"}
                          value={
                            v?.RECEIVED_FROM == "1"
                              ? "Phone Pay"
                              : v?.RECEIVED_FROM == "2"
                              ? "Google Pay"
                              : v?.RECEIVED_FROM == "3"
                              ? "Paytm"
                              : v?.RECEIVED_FROM == "4"
                              ? "Cred"
                              : v?.RECEIVED_FROM == "5"
                              ? "Others"
                              : v?.RECEIVED_FROM
                          }
                        />
                      )}

                      <RowTxt title={"Bank Account"} value={v?.BANK_ACC_NO} />
                    </>
                  )}
                  <RowTxt title={"Created By"} value={v?.CREATED_NAME || "-"} />
                </div>
                <div
                  className="df jcsb mt10"
                  // style={{
                  //   justifyContent:
                  //     user_type != "admin" && v?.EMPLOYEE_CODE != emp_id
                  //       ? "flex-end"
                  //       : "space-between",
                  // }}
                >
                  {v?.STATUS_FLAG == 0 ? (
                    <>
                      {user_type == "admin" || v?.EMPLOYEE_CODE == emp_id ? (
                        <DeleteIcon
                          onClick={() => {
                            setId(v?.ID);
                            setOpen(true);
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <div></div>
                  )}

                  {token_status == 1 && (
                    <>
                      {v?.CVO_TIN?.length == 15 && (
                        <Tooltip
                          content={
                            v?.EINVOICE_PDF_URL
                              ? "Print E-Invoice"
                              : "Genrate E-Invoice"
                          }
                        >
                          {/* <ReactPrint
                            num={
                              <TbFileInvoice
                                onClick={() =>
                                  genrate_e_invoice(v?.SR_NO, v?.ID)
                                }
                                color="#007bff"
                                size={20}
                                cursor={"pointer"}
                              />
                            }
                            v={v}
                            setViewItem={setViewItem}
                            documentTitle={`${v?.cvo_name || v?.CUST_NAME}-${
                              v?.SR_NO
                            }`}
                            content={() => previewRef.current}
                            previewRef={previewRef}
                          /> */}
                          <TbFileInvoice
                            onClick={() => {
                              // console.log("print_E-Invoice ===", v);

                              if (v?.EINVOICE_PDF_URL) {
                                // toast.success("E-Invoice Already Generated");
                                print_e_way_bill(v?.EINVOICE_PDF_URL);
                              } else {
                                genrate_e_invoice(v?.SR_NO, v?.ID);
                              }
                            }}
                            color={v?.EINVOICE_PDF_URL ? "gray" : "#007bff"}
                            size={20}
                            cursor={"pointer"}
                          />
                        </Tooltip>
                      )}
                      {Number(v?.SI_AMOUNT).toFixed(2) > 50000 && (
                        // <Tooltip content={"E-Way Bill"}>
                        <Tooltip
                          content={
                            v?.EWAY_BILL_STATUS
                              ? "Print E-Way Bil"
                              : "Genrate E-Way Bil"
                          }
                        >
                          <LiaFileInvoiceSolid
                            onClick={() => {
                              if (v?.EWAY_BILL_STATUS) {
                                print_e_way_bill(
                                  "https://" + v?.E_WAY_BILL_URL
                                );
                              } else {
                                genrate_e_way_bill(v?.SR_NO);
                              }
                            }}
                            color={v?.EWAY_BILL_STATUS ? "gray" : "#007bff"}
                            size={20}
                            cursor={"pointer"}
                          />
                        </Tooltip>
                      )}
                    </>
                  )}

                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 1.05 }}
                    className="flex aic gap10 jce cursor-pointer"
                  >
                    <div
                      className="view-btn"
                      onClick={() => {
                        setOpenView(true);
                        setViewItem(v);
                      }}
                    >
                      View
                    </div>
                    <HiOutlineArrowRight
                      size={20}
                      color="#1b64af"
                      onClick={() => {
                        setOpenView(true);
                        setViewItem(v);
                      }}
                    />
                  </motion.div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Pagination3>

      {isAdd && (
        <AddCommercial
          isAdd={isAdd}
          setIsAdd={setIsAdd}
          setMess={setMess}
          mess={mess}
          setOpen1={setOpen1}
          setLoading={setLoading}
          obj={obj}
        />
      )}

      <div style={{ display: "none" }}>
        <TaxInvoice3
          empty_row_height={180 - viewItem?.products?.length * 25}
          previewRef={previewRef}
          irn={viewItem?.IRN}
          listdata={{
            SR_NO: viewItem?.SR_NO,
            SR_NO_DATE: viewItem?.SI_DATE,
            REF_NUMBER: viewItem?.PO_NO,
            REF_DATE: viewItem?.PO_DATE,
            CVO_NAME: viewItem?.cvo_name,
            CVO_ADDRESS: viewItem?.CVO_ADDRESS || viewItem?.BILLING_ADDRESS,
            CVO_DISTRICT: viewItem?.B_DISTRICT,
            CVO_LOCATION: viewItem?.B_LOCATION,
            B_STATE_CODE: viewItem?.B_STATE,
            B_STATE_NAME: viewItem?.B_STATE_NAME,
            CVO_PINCODE: viewItem?.PINCODE,
            CVO_TIN:
              viewItem?.CVO_TIN ||
              (viewItem?.CUST_GSTIN == "0" ? "" : viewItem?.CUST_GSTIN) ||
              "NA",
            EMAIL: viewItem?.CVO_EMAIL,
            MOBILE: viewItem?.CVO_CONTACT,
            SHIP_CVO_NAME: viewItem?.cvo_name,
            SHIP_CVO_ADDRESS: viewItem?.S_ADDRESS || viewItem?.BILLING_ADDRESS,
            SHIP_CVO_DISTRICT: viewItem?.S_DISTRICT,
            SHIP_CVO_LOCATION: viewItem?.S_LOCATION,
            SHIP_B_STATE: viewItem?.S_STATE,
            SHIP_B_STATE_NAME: viewItem?.S_STATE_NAME,
            SHIP_CVO_PINCODE: viewItem?.S_PINCODE,
            SHIP_CVO_TIN:
              viewItem?.CVO_TIN ||
              (viewItem?.CUST_GSTIN == "0" ? "" : viewItem?.CUST_GSTIN) ||
              "NA",
            vehicle_num: viewItem?.vehicle_number,
            // Other info
            irn_date: viewItem?.ACK_DATE,
            eway_bill: viewItem?.EWAY_BILL_NO,
            eway_bill_date: viewItem?.EWAY_BILL_DATE,
            irn_qr: viewItem?.QRCODE_URL,
            pay_terms:
              viewItem?.PAYMENT_TERMS == "1"
                ? "Cash"
                : viewItem?.PAYMENT_TERMS == "2"
                ? "Credit"
                : "",
            dc_num: viewItem?.DC_NO,
            dc_num_date: viewItem?.DC_DATE,
          }}
          table_body={
            <>
              {viewItem?.products?.map((v, i) => (
                <tr key={i}>
                  <td className="both">{i + 1}</td>
                  <td
                    style={{
                      textAlign: "left",
                      fontWeight: "bold",
                      minWidth: "250px",
                    }}
                    className="both"
                  >
                    {/* {`${v?.CAT_NAME } - ${v?.CAT_DESC}`} */}
                    COMM-LPG-{v?.CAT_DESC}
                  </td>
                  <td className="both">{v?.HSNCODE}</td>
                  <td className="both">
                    {Number(v?.QUANTITY) - Number(v?.PSV_CYLS)}{" "}
                    {UnitFunction(v?.UNITS || v?.UOM, "title")}
                  </td>
                  <td className="both">{Number(v?.UNIT_RATE).toFixed(2)}</td>
                  <td className="both">{v?.DISC_UNIT_RATE}</td>
                  <td className="both">{v?.GSTP} %</td>
                  <td className="both" style={{ textAlign: "right" }}>
                    {(
                      (Number(v?.QUANTITY) - Number(v?.PSV_CYLS)) *
                      (Number(v?.UNIT_RATE) - Number(v?.DISC_UNIT_RATE))
                    ).toFixed(2)}
                  </td>
                </tr>
              ))}
            </>
          }
          Total_tax={ReduceFunction(viewItem?.hsn_groups, "TOTAL_AMOUNT")}
          net_total={Number(viewItem?.SI_AMOUNT).toFixed(2)}
          taxable_amt={ReduceFunction(viewItem?.products, "TAXABLE_AMOUNT")}
          igst={ReduceFunction(viewItem?.products, "IGST_AMOUNT")}
          cgst={ReduceFunction(viewItem?.products, "CGST_AMOUNT")}
          sgst={ReduceFunction(viewItem?.products, "SGST_AMOUNT")}
          other={(
            Number(ReduceFunction(viewItem?.products, "TRANSPORT_CHARGES")) +
            (Number(ReduceFunction(viewItem?.products, "TRANSPORT_CHARGES")) *
              18) /
              100 +
            (viewItem?.SYNC_FLAG == 1
              ? Number(ReduceFunction(viewItem?.products, "TCS_AMOUNT"))
              : viewItem?.SYNC_FLAG == 2
              ? -Number(ReduceFunction(viewItem?.products, "TCS_AMOUNT"))
              : 0)
          ).toFixed(2)}
        />
      </div>

      {openView && (
        <Modal
          isOpen={openView}
          onCancel={() => {
            setViewItem({});
          }}
          header_right={
            <div className="flex gap10 ">
              {viewItem?.EWAY_BILL_NO && (
                <Button
                  style={{ cursor: "pointer" }}
                  title={"CANCEL E-WAY BILL"}
                  onClick={() => cancle_e_way_bill(viewItem?.EWAY_BILL_NO)}
                />
              )}
              {viewItem?.EWAY_BILL_STATUS && (
                <Button
                  style={{ cursor: "pointer" }}
                  title={"PRINT E-WAY BILL"}
                  onClick={() =>
                    print_e_way_bill("https://" + viewItem?.E_WAY_BILL_URL)
                  }
                />
              )}

              {/* {viewItem?.IRN && (
                <Button
                  style={{ cursor: "pointer" }}
                  title={"CANCEL E-INVOICE-INVOICE "}
                  onClick={() => cancle_e_invoice(viewItem?.IRN)}
                />
              )} */}

              <ReactToPrint
                trigger={() => (
                  <Button style={{ cursor: "pointer" }} title={"PRINT"} />
                )}
                content={() => previewRef.current}
                documentTitle={`${viewItem?.cvo_name || viewItem?.CUST_NAME}-${
                  viewItem?.SR_NO
                }`}
              />
            </div>
          }
          title={viewItem?.cvo_name || viewItem?.CUST_NAME}
          setIsOpen={setOpenView}
          body={
            <>
              {viewItem?.DC_NO && (
                <div
                  style={{
                    display: "flex",
                    gap: "2rem",
                  }}
                >
                  <div>DC Number : {viewItem?.DC_NO}</div>
                  <div>
                    DC Date : {moment(viewItem?.DC_DATE).format("DD/MM/YYYY")}
                  </div>
                </div>
              )}
              {/* {viewItem?.CUSTOMER_STATUS == "2" && ( */}
              {/* <>
                {viewItem?.CUST_GSTIN && (
                  <div className="rowtxt">
                    <div
                      className="card-label card-label-width"
                      style={{ maxWidth: "100px", minWidth: "100px" }}
                    >
                      GSTIN No.
                    </div>
                    <div className="card-label">:</div>
                    <div className="card-title" style={{ textWrap: "wrap" }}>
                      {viewItem?.CUST_GSTIN}
                    </div>
                  </div>
                )}
                {viewItem?.BILLING_ADDRESS && (
                  <div className="rowtxt">
                    <div
                      className="card-label card-label-width"
                      style={{ maxWidth: "100px", minWidth: "100px" }}
                    >
                      Address
                    </div>
                    <div className="card-label">:</div>
                    <div className="card-title" style={{ textWrap: "wrap" }}>
                      {viewItem?.BILLING_ADDRESS}
                    </div>
                  </div>
                )}
              </> */}
              {viewItem?.CUSTOMER_ID == "0" && (
                <>
                  {viewItem?.CUST_GSTIN && (
                    <div className="rowtxt">
                      <div
                        className="card-label "
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                      >
                        GSTIN No.
                      </div>
                      <div className="card-label">:</div>
                      <div className="card-title" style={{ textWrap: "wrap" }}>
                        {viewItem?.CUST_GSTIN}
                      </div>
                    </div>
                  )}
                  <div className="rowtxt">
                    <div
                      className="card-label "
                      style={{ maxWidth: "100px", minWidth: "100px" }}
                    >
                      Address
                    </div>
                    <div className="card-label">:</div>
                    <div className="card-title" style={{ textWrap: "wrap" }}>
                      {viewItem?.BILLING_ADDRESS}
                    </div>
                  </div>
                </>
              )}
              {/* )} */}
              <Table
                mt={10}
                headData={[
                  "PRODUCT",
                  "DELIVERED BY",
                  // "BANK ACCOUNT",
                  "AREA CODE",
                  "NARRATION",
                  "GST%",
                  "UNIT PRICE",
                  "DISCOUNT ON UNIT PRICE",
                  "QUANTITY",
                  "PSV CYLINDERS",
                  "EMPTIES RECEIVED",
                  "TRANSPORT CHARGES",
                  "TDS/TCS",
                  "TOTAL AMOUNT",
                ]}
                body={
                  <>
                    {viewItem?.products?.map((v, i) => (
                      <tr key={i}>
                        <td>{`${v?.CAT_NAME} - ${v?.CAT_DESC}`}</td>
                        <td>{v?.EMP_NAME}</td>
                        {/* <td>{v?.BANK_ACC_NO || "NA"}</td> */}
                        <td>{v?.AREA_CODE}</td>
                        <td>{v?.NARRATION}</td>
                        <td>{v?.GSTP}</td>
                        <td>{Number(v?.UNIT_RATE).toFixed(2)}</td>

                        <td>{Number(v?.DISC_UNIT_RATE).toFixed(2)}</td>
                        <td>{v?.QUANTITY}</td>
                        <td>{Number(v?.PSV_CYLS).toFixed(0)}</td>
                        <td>{Number(v?.EMPTY_RECEIVED).toFixed(0)}</td>
                        <td>{Number(v?.TRANSPORT_CHARGES).toFixed(2)}</td>
                        <td>
                          {viewItem?.SYNC_FLAG == "2" ? "-" : ""}{" "}
                          {Number(v?.TCS_AMOUNT).toFixed(2)}
                        </td>
                        <td>{Number(v?.SALE_AMOUNT).toFixed(2)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={9} />
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        TOTAL
                      </td>
                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {viewItem?.products
                          .map((v) => v?.TRANSPORT_CHARGES)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                          ?.toFixed(2)}
                      </td>
                      <td />

                      <td style={{ fontWeight: "bold", fontSize: "15px" }}>
                        {viewItem?.products
                          .map((v) => v?.SALE_AMOUNT)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                          ?.toFixed(2)}
                      </td>
                    </tr>
                  </>
                }
              />
            </>
          }
        ></Modal>
      )}

      {open && (
        <SmallModal
          title={"Confirm"}
          isOpen={open}
          setIsOpen={setOpen}
          mess={"Are you sure? You want to delete"}
          onClick={() => onDelete_item()}
        />
      )}
      {open1 && (
        <SmallModal
          title={"Alerts"}
          isOpen={open1}
          setIsOpen={setOpen1}
          mess={mess}
          okbtn={true}
        />
      )}

      {loading && <Loader />}
    </div>
  );
};
